// Plain-language helpers for statement periods (dates are 'YYYY-MM-DD').
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const dayLabel = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''));
  return m ? `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}` : '';
};

export const periodLabel = (p) => (p ? `${dayLabel(p.period_start)} to ${dayLabel(p.period_end)}` : '');

// "Closes on the 15th of each month" / "Calendar month".
export const closingDayText = (day) => {
  const n = Number(day);
  if (!day || !Number.isInteger(n) || n < 1 || n > 31) return 'Calendar month (closes on the last day of each month)';
  const suffix = n % 10 === 1 && n !== 11 ? 'st' : n % 10 === 2 && n !== 12 ? 'nd' : n % 10 === 3 && n !== 13 ? 'rd' : 'th';
  return n >= 29 ? `Closes on the ${n}${suffix} (or the last day in shorter months)` : `Closes on the ${n}${suffix} of each month`;
};

// Rows dated before the period start that are still open (carried in).
export const isCarriedIn = (row, start) => String((row && row.transaction_date) || '').slice(0, 10) < String(start || '');

// Plain-language note: statement periods begin after the last month period.
export const monthBoundaryNote = (lastMonthEnd) => {
  const end = dayLabel(lastMonthEnd);
  if (!end) return 'Statement periods cannot overlap a month you reconcile on the month grid.';
  return `Your last month on the month grid ends ${end}. Statement periods start after it and cannot overlap it, so the next one starts ${dayLabel(nextDay(lastMonthEnd))}.`;
};

function nextDay(d) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''));
  if (!m) return '';
  const t = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + 1));
  return t.toISOString().slice(0, 10);
}
